<div class="banner-wrapper">
    <div
        class="banner"
        [style.background-image]="'url(assets/images/empty-page/' + imgName() + ')'"
        [style.background-position]="backgroundPosition()"
    ></div>
    <div class="banner-info">
        <div class="headline">{{ headlineKey() | translate }}</div>
        @if (!descriptionAsInnerHtml()) {
            <div class="description">{{ descriptionKey() | translate }}</div>
        }
        @if (descriptionAsInnerHtml()) {
            <!-- eslint-disable-next-line @nx/workspace-ebiz-no-inner-html -->
            <div class="description" [innerHtml]="descriptionKey() | translate"></div>
        }
        @if (!hideBtn()) {
            <div class="action-btn-container">
                <warema-button
                    class="action-btn"
                    id="action-btn"
                    size="small"
                    [href]="btnHref()"
                    [iconRight]="btnIconScr()"
                    [queryParams]="btnQueryParams()"
                    [routerLink]="btnRouterLink() ? [btnRouterLink()] : null"
                    [target]="btnTarget()"
                    [text]="btnTextKey() | translate"
                />
            </div>
        }
        <ng-content />
    </div>
</div>
